export default __webpack_public_path__ + "static/media/team-3.27503ede.jpg";